import app from 'flarum/forum/app';
import followingPageOptions from '../../common/utils/followingPageOptions';
export let options;
export const getOptions = () => {
  if (!options) {
    options = followingPageOptions('forum.index.following');
  }
  return options;
};
export const getDefaultFollowingFiltering = () => {
  getOptions();
  let value = app.forum.attribute('fofFollowTagsFollowingPageDefault');
  if (value && !options[value]) {
    value = null;
  }
  if (app.session.user) {
    const preference = app.session.user.preferences()?.followTagsPageDefault;
    if (preference && options[preference]) {
      value = preference;
    }
  }
  return value || 'none';
};
flarum.reg.add('fof-follow-tags', 'forum/utils/getDefaultFollowingFiltering', { options: options,getOptions: getOptions,getDefaultFollowingFiltering: getDefaultFollowingFiltering, });